import PropTypes from 'prop-types'

import InnerText from './InnerText'

const Content = ({ handleOnClose, text }) => (
  <div className='container'>
    <InnerText text={text} />
    <button
      aria-label='close'
      className='close flash__close'
      datadismiss='alert'
      onClick={handleOnClose}
      type='button'
    >
      <span aria-hidden='true'>{'x'}</span>
    </button>
  </div>
)

export default Content

Content.propTypes = {
  handleOnClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}
